module.exports = __webpack_public_path__ + "static/img/index-brand.874b17ec.jpg";